// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-478437a2] {\n  height: 20px !important;\n  width: 20px !important;\n  vertical-align: -5px !important;\n}\n[data-v-478437a2] .el-checkbox__label {\n  color: #333;\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
